import React, {useEffect, useState} from 'react';
import {Language} from '../../constants/language.constants';
import {PageType} from '../../download/constants';
import useQuery from '../../hooks/useQuery';
import {API} from '../../classes/API';
import {LaunchPage} from '../LaunchPage/LaunchPage';
import {InviteParameters} from '../../download/interface';

type InvitePageProps = {
  language?: Language;
};

export function InvitePage({language}: InvitePageProps): JSX.Element {
  const api = API.getInstance();
  const query = useQuery();
  const [parameters, setParameters] = useState<InviteParameters | null>(null);

  const storyId = query.get('story');
  const inviterProfileId = query.get('inviter') ?? parameters?.inviterProfileId;
  const goto = parameters?.storyId ? 'story' : 'profile';

  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (inviterProfileId) {
      api
        .getProfile(inviterProfileId)
        .then(({data: profile, error}) => {
          if (!profile) {
            console.warn(
              'Failed to get profile by id ' + inviterProfileId,
              error,
            );
            return;
          }
          setParameters(p => ({
            profileId: inviterProfileId,
            ...p,
            inviterFirstName: profile.firstName,
            inviterProfileId,
            inviterAvatarUri: api.getPublicURL(profile.avatar?.URI),
          }));

          if (goto === 'profile') {
            setReady(true);
          }
        })
        .catch(error => {
          console.error(
            'Failed to get profile by id ' + inviterProfileId,
            error,
          );
        });
    }
  }, [api, goto, inviterProfileId]);

  useEffect(() => {
    if (storyId) {
      api.getStory(storyId).then(({data: story, error}) => {
        if (!story) {
          console.warn('Failed to get story by id ' + storyId, error);
          return;
        }
        if (!story.profileId) {
          console.warn('Story has no profile id: story ' + storyId, error);
          return;
        }

        setParameters(p => ({
          ...p,
          profileId: story.profileId ?? undefined,
          authorProfileId: story.profileId ?? undefined,
          authorFirstName:
            story.Profile?.firstName ?? story.CompanyProfile?.name ?? undefined,
          authorAvatarUri: api.getPublicURL(
            story.Profile?.avatar?.URI ?? story.CompanyProfile?.logo?.URI,
          ),
          storyId,
        }));

        if (goto === 'story') {
          setReady(true);
        }
      });
    }
  }, [api, goto, storyId]);

  return (
    <LaunchPage
      language={language}
      parameters={parameters}
      ready={ready}
      type={
        parameters?.storyId
          ? PageType.DOWNLOAD_SHARE_STORY
          : PageType.DOWNLOAD_INVITE
      }
      goto={goto}
    />
  );
}
